import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { CreateAccountForm } from "@/components/account/CreateAccountForm";
import { useTranslation } from "react-i18next";

interface CreateAccountDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: () => void;
  isLoading: boolean;
}

export const CreateAccountDialog = ({
  open,
  onOpenChange,
  onSubmit,
  isLoading,
}: CreateAccountDialogProps) => {
  const { t } = useTranslation();
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md p-6">
        <DialogHeader>
          <DialogTitle>{t("accounts.create_new_account")}</DialogTitle>
          <DialogDescription>
            {t("accounts.scan_qr_code_to_connect")}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          <CreateAccountForm
            onSubmit={onSubmit}
            onCancel={() => onOpenChange(false)}
            isLoading={isLoading}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
